import React, {Fragment, PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import AskReinforcement from '../../../components/AskReinforcement/AskReinforcement.jsx';
import CalendlyButton from '../../../components/CalendlyButton/CalendlyButton.jsx';
import Header from '../../../components/Header/Header.jsx';
import Landing from '../Landing.jsx';
import OurDifferences from '../../../components/OurDifferences/OurDifferences.jsx';
import OurJobs from '../../../components/OurJobs/OurJobs.jsx';
import References from '../../../components/References/References.jsx';

import {generate} from '../../../routes.js';
import conf from '../../../conf.js';

import header from './images/header.jpg?size=600';
import person from './images/person.svg';
import financeImg from './images/finance.jpg?size=600';
import purchaseImg from './images/purchase.jpg?size=600';
import hrImg from './images/hr.jpg?size=600';

const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition Achats, Finance
    ou RH</strong>, Twineeds est la plateforme qu'il vous faut.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const ourJobsItems = [
  {
    title: 'Achats, approvisionnement et Supply Chain',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> achats et approvisionnements (tels que ' +
      '<strong>acheteurs, gestionnaire de contrats</strong> etc.) mais également vos équipes d’opérations (tels que ' +
      '<strong>logisticien, responsable transport, gestionnaire de flux, chef de projet</strong> etc.)</p>',
    img: purchaseImg.src
  },
  {
    title: 'Finance',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> Finance : <strong>Directeur financier, ' +
      'technicien comptable, trésorier, analyste d’affaires, comptabilité, Comptable Professionnel Agréé (CPA)' +
      '</strong>, etc.</p>',
    img: financeImg.src
  },
  {
    title: 'Ressources Humaines',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> Ressources Humaines : <strong>Conseiller(ère) ' +
      'en ressources humaines agréés (CRHA), technicien(ne) de la paie, chargé(e) projet SIRH, technicien(ne) en ' +
      'recrutement,</strong> etc.</p>',
    img: hrImg.src
  }
];

class LandingCompany extends PureComponent {
  render() {
    const headerCtas = <Fragment>
      <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer un mandat</Link>
      <CalendlyButton className="btn btn-secondary" meetingUrl={conf.calendly.do}>Être rappelé(e)</CalendlyButton>
    </Fragment>;

    return <Landing
      className="landing-company"
      metaDescription="Découvrez les différents profils de consultant inscrits sur notre plateforme : un expert, un renfort pour vos équipes ou un gestionnaire de transition Achats, RH ou Finance"
      metaTitle="Trouvez des renforts pour vos équipes"
    >
      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={''}
        imageSrc={header.src}
        title="Besoin de spécialistes des fonctions support&nbsp;?"
      />

      <div className="bg-light">
        <References className="container text-center py-5"/>
      </div>

      <OurJobs items={ourJobsItems}/>

      <div className="bg-light">
        <AskReinforcement/>
      </div>

      <OurDifferences specificDifference={
        <Fragment>
          <strong>Une large gamme de compétences sur les fonctions support</strong>, utile dans le cadre de
          transformations / sujets transverses.
        </Fragment>
      }/>

      <div className="bg-light">
        <section id="benefits" className="container py-5">
          <div className="row text-center">
            <div className="col-md-12 offset-md-1 mb-4 mb-md-0">
              <img className="mb-4" src={person} alt={''}/>
              <h3>100% des travailleurs autonomes préqualifiés</h3>
              <p>
                Tous nos travailleurs autonomes ont été rencontrés et qualifiés afin de vous assurer de la réelle
                adéquation entre vos besoins et leurs qualifications.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Landing>;
  }
}

export default connect(
  state => ({
    universes: state.universe.universes,
  })
)(LandingCompany);
